import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import Clothes from "../../models/clothes/clothes.model";

interface FavoritesStateType {
    favorites: Clothes[]
}

const initialState: FavoritesStateType = {
    favorites: []
}

export const FavoritesSlice = createSlice({
    name: "Favorites",
    initialState: initialState,
    reducers: {
        setFavorites: (state, action: PayloadAction<Clothes[]>) => {
            state.favorites = [...action.payload];
        }
    }
});

export default FavoritesSlice.reducer;
export const {
    setFavorites
} = FavoritesSlice.actions;